import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TimeFrame, TIMEFRAMES } from 'libs/portal/src/models/types/Timeframes';
import { TimePeriod, TIMEPERIODS } from 'libs/portal/src/models/types/TimePeriods';
@Component({
  selector: 'tools-time-frame-selector',
  templateUrl: './time-frame-selector.component.html',
  styleUrls: ['./time-frame-selector.component.scss'],
})
export class TimeFrameSelectorComponent implements OnInit {
  TimeFrames = TIMEFRAMES.filter((elem: TimeFrame) => {
    return [1, 2, 3, 4, 5, 6, 7].includes(elem.iD);
  });
  TimePeriods = TIMEPERIODS.filter((elem: TimePeriod) => {
    return [2, 3, 4].includes(elem.iD);
  });

  @Input() selectedInterval = 1;
  @Input() selectedTimeFrame: TimeFrame;
  @Input() selectedTimePeriod: TimePeriod;
  @Input() timeFrameOptions: number[];
  @Input() timePeriodOptions: number[];
  @Input() intervalDisabled: boolean = false;
  @Input() timeFrameDisabled: boolean = false;

  compareWith: Function;
  @Output() intervalChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() timeFrameChanged: EventEmitter<TimeFrame> = new EventEmitter<TimeFrame>();
  @Output() timePeriodChanged: EventEmitter<TimePeriod> = new EventEmitter<TimePeriod>();

  constructor() {}

  ngOnInit() {
    if (this.timeFrameOptions && this.timeFrameOptions.length > 0) {
      this.TimeFrames = TIMEFRAMES.filter((elem: TimeFrame) => {
        return this.timeFrameOptions.includes(elem.iD);
      });
    }

    if (this.timePeriodOptions && this.timePeriodOptions.length > 0) {
      this.TimePeriods = TIMEPERIODS.filter((elem: TimePeriod) => {
        return this.timePeriodOptions.includes(elem.iD);
      });
    }
    this.compareWith = this.compareWithFn;
    if (!this.selectedTimePeriod) this.selectedTimePeriod = this.TimePeriods[0];
    if (!this.selectedTimeFrame) this.selectedTimeFrame = this.TimeFrames[0];
  }

  /**
   *
   * @param eve CustomEvent on input change
   */
  intervalInputChanged(eve) {
    console.log(eve.target.value);
    this.selectedInterval = parseInt(eve.target.value);
    this.intervalChanged.emit(this.selectedInterval);
  }

  /**
   *
   * @param id Primary key of the Time Frame selected
   */
  timeFrameInputChanged(id: number) {
    console.log(id);

    this.timeFrameChanged.emit(this.TimeFrames.find((x: TimeFrame) => x.iD == id));
  }

  /**
   *
   * @param id Primary key of the Time Period selected
   */
  timePeriodInputChanged(id: number) {
    console.log(id);

    this.timePeriodChanged.emit(this.TimePeriods.find((x: TimePeriod) => x.iD == id));
  }

  /**
   *
   * @param o1 Either TimePeriod | TimeFrame object
   * @param o2 Either TimePeriod | TimeFrame object
   * @returns boolean to check equivalence
   */
  compareWithFn = (o1: TimePeriod | TimeFrame, o2: TimePeriod | TimeFrame): boolean => {
    return o1 == o2;
  };
}
